export default __webpack_public_path__ + "static/media/travel_guide_new_1.230f969d.gif";